import type { AgeCheckState, ProcessVisitorResponse } from '../../types'

// only an explicit 0 lifts the age gate; www treats any truthy value as ACR
export const isAgeCheckRequired = (
    ageCheckRequired: ProcessVisitorResponse['age_check_required'],
) => ageCheckRequired !== 0

export const getAgeCheckState = ({
    age_check_required,
}: Pick<ProcessVisitorResponse, 'age_check_required'>): AgeCheckState => ({
    active: isAgeCheckRequired(age_check_required),
})
